import { useMemo } from "react";
import { useGetNotifications } from "security-app/hooks/useSigmaAPI";
export function useNotificationOptions() {
  const { notifications, loadingNotifications } = useGetNotifications();
  const notificationOptions = useMemo(
    () => notifications.map((notification) => ({
      label: notification.title,
      value: notification.id
    })),
    [notifications]
  );
  return { loadingNotifications, notificationOptions };
}
